import React from "react";

import {
  FiArrowRight,
  FiCalendar,
  FiFileText,
  FiZap,
} from "react-icons/fi";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"

const LandingPage = ({ openSheet }) => {
  return (
    <section className="fw-screen fw-screen--landing fw-fade">
      <div className="fw-hero">

        <div className="fw-brand">
          <img 
            src={fundwalelogo} 
            alt="Fundswalle" 
            className="fw-brand__logo" 
          />
        </div>

        <h1 className="fw-landing-title">
  <span className="fw-landing-title__top">Instant Loan for</span>
  <span className="fw-landing-title__bottom">Salaried Employees</span>
</h1>

        <p className="fw-hero__amount">
          upto <b>₹1,00,000</b>
        </p>
      </div>

      <div className="fw-benefits">
        <button
          type="button"
          className="fw-card"
          onClick={() => openSheet("mobile")}
        >
          <span className="fw-card__icon fw-card__icon--gold">
            <FiZap />
          </span>

          <div>
            <h2>Instant Loan</h2>
            <p>Fast approval and disbursal within 24 hours.</p>
          </div>
        </button>

        <button
          type="button"
          className="fw-card"
          onClick={() => openSheet("mobile")}
        >
          <span className="fw-card__icon fw-card__icon--purple">
            <FiFileText />
          </span>

          <div>
            <h2>100% Paperless</h2>
            <p>Apply easily through a secure digital process.</p>
          </div>
        </button>

        <button
          type="button"
          className="fw-card"
          onClick={() => openSheet("mobile")}
        >
          <span className="fw-card__icon fw-card__icon--blue">
            <FiCalendar />
          </span>

          <div>
            <h2>Flexible EMIs</h2>
            <p>Choose a repayment plan that fits your budget.</p>
          </div>
        </button>
      </div>

      <button
        type="button"
        className="fw-cta"
        onClick={() => openSheet("mobile")}
      >
        Apply Now

        <span className="fw-cta__arrow" aria-hidden="true">
          <FiArrowRight />
        </span>
      </button>
    </section>
  );
};

export default LandingPage;